import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const UserIconSolidCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <SVGUniqueID>
    <svg
      width={36}
      height={36}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={36} height={36} rx={18} fill="#E2E8F0" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.89365 24.095C11.9819 21.8802 14.8377 20.5 18 20.5C21.1623 20.5 24.0181 21.8802 26.1063 24.095C26.3345 24.337 26.3969 24.6915 26.2651 24.9969C26.1333 25.3022 25.8326 25.5 25.5 25.5H10.5C10.1674 25.5 9.86664 25.3022 9.73485 24.9969C9.60307 24.6915 9.66548 24.337 9.89365 24.095Z"
        fill="#64748B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4166 14.25C13.4166 11.7187 15.4687 9.66666 18 9.66666C20.5313 9.66666 22.5833 11.7187 22.5833 14.25C22.5833 16.7813 20.5313 18.8333 18 18.8333C15.4687 18.8333 13.4166 16.7813 13.4166 14.25Z"
        fill="#64748B"
      />
    </svg>
  </SVGUniqueID>
);
export { UserIconSolidCircle };
